import React, { useEffect, useState } from 'react'
import Alert from '~/Common-Objects/UI/Alert'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import axios from '~/data/http/axios'
import EmailValidator from '~/Classes/emailValidator'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import { Tooltip } from 'react-tooltip'
const systemLinks = ['{{{__UNSUBSCRIBE_URL}}}', '{{{__UPDATE_URL}}}', '{{{__JUNK_URL}}}', '{{{__PREVIEW_URL}}}']

export default function LinkChecker({ templateId, templateJson = {}, selectElement = () => {} }) {
    const [links, setLinks] = useState(null)
    const [randomId, setRandomId] = useState(0)
    useEffect(() => {
        axios.get('/template/' + templateId + '/validateLinks').then((res) => {
            const links = res.data.map(link => ({
                ...link,
                error: '',
                errorIcon: 'tickCircle',
                errorColor: 'var(--cyan-500)',
                elementPath: '',
                tuuid: '',
                loading: true
            }))
            setLinks(links)
        })
    }, [templateId])

    useEffect(() => {
        if(links){
            checkLinks();
        }
    }, [links])

    async function checkLinks(){
        const linksChecked = [];
        for(let index = 0; index < links.length; index++){
            const linkHref = links[index].href;
            const linkObject = links[index];

            //set defaults
            linkObject.error = ''
            linkObject.errorIcon = 'tickCircle'
            linkObject.errorColor = 'var(--cyan-500)'
            linkObject.elementPath = "";
            linkObject.tuuid = "";
            let foundElements = null;
            if(linkHref){
                foundElements = DragDropFunctions.findElementsThatMatchLinkValue(templateJson, linkHref)
                linksChecked.push(linkHref);
                let totalLinksOfThisType = linksChecked.filter(l => l == linkHref).length - 1;
                linkObject.tuuid = foundElements.elements[totalLinksOfThisType]?.tuuid;
                linkObject.elementPath = foundElements.paths[totalLinksOfThisType];
            }

            if (!linkHref) {
                //cant really figure out matching elements for these (tuuid/path etc)
                linkObject.error = 'Blank Link'
                linkObject.errorIcon = 'alert'
                linkObject.errorColor = 'var(--yellow-500)'
                continue;
            }
            else if (systemLinks.indexOf(linkHref) > -1) {
            }
            else if (linkHref.indexOf('mailto:') === 0) {

                let emailAddress = linkHref.split('mailto:')[1]
                if (emailAddress) {
                    emailAddress = emailAddress.split('?')[0]
                }
                if (!EmailValidator.validateEmail(emailAddress)) {
                        linkObject.error = 'Invalid Email Address'
                        linkObject.errorIcon = 'alert'
                        linkObject.errorColor = 'var(--yellow-500)'
                }
            }
            else if (linkHref == 'tel:' || linkHref == 'tel://') {
                    linkObject.error = 'Invalid Phone Number'
                    linkObject.errorIcon = 'alert'
                    linkObject.errorColor = 'var(--yellow-500)'
            }
            else {
                let linkResult =  await axios.post('/template/' + templateId + '/links/validate', {
                    link: linkHref
                })
                if(!linkResult.data.valid){
                    linkObject.error = 'Invalid Link'
                    linkObject.errorIcon = 'alert'
                    linkObject.errorColor = 'var(--yellow-500)'
                }
            }
            linkObject.loading = false;
        }
        setLinks(links);
        setRandomId(randomId + 1);
    }

    if (!links) {
        return <LoadingIcons iconType='2' />
    }

    const nonSystemLinks = links.filter((l) => systemLinks.indexOf(l.href) === -1)

    return (
        <div data-test='dndEditorv2-link-checker'>
            {!nonSystemLinks.length && (
                <Alert className="text-center" header="No links found" content="We didn't find any links in your template." type="info" hideIcon={true} />
            )}
            {nonSystemLinks.map((link, index) => {
               
               let classes = 'dndEditorv2-linkChecker '
               if(link.href && !link.loading){
                classes += 'dndEditorv2-linkChecker-clickable '
                if(link.error){
                    classes += 'dndEditorv2-linkChecker-error '
                }
               }
                return (
                    <div key={index} className={classes} onClick={()=>{
                        selectElement(link.elementPath, true, link.tuuid);
                    }}>
                        {!!link.src && (
                            <div className='dndEditorv2-linkCheckerImage'>
                                <img src={link.src} />
                            </div>
                        )}

                        <div className='dndEditorv2-linkCheckerText'>
                            {!link.src && (
                                <div 
                                    className='dndEditorv2-linkCheckerTitle'>
                                    {link.text || link.href}
                                </div>
                            )}
                            <div className='dndEditorv2-linkCheckerUrl'>
                                {link.href}
                            </div>
                        </div>

                        <div className='dndEditorv2-linkCheckerError'>
                            {link.errorIcon && !link.loading && (
                                <Icons
                                    data-tooltip-content={link.error}
                                    data-tooltip-id={`linkChecker-error-${index}`}
                                    data-tooltip-style={{maxWidth: "200px", zIndex: 99999}}
                                    data-tooltip-position="right"
                                    icon={link.errorIcon}
                                    color={link.errorColor}
                                    style={{ width: 16, height: 16 }}
                                />
                            )}
                            {link?.loading&& (
                                <LoadingIcons iconType='2' style={{ width: 16, height: 16 }} />
                            )}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
